module.exports = {
    host: "https://bkbaza2.vastok.uz",
    // host: "http://localhost:8000",
    // host: "https://backend.gold-uz.uz",
};
